import { fetcher, endpoints } from 'src/utils/axios';

const { default: useSWR } = require('swr');

const useMemberships = () =>
  useSWR(endpoints.auth.getMemberships, fetcher, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

export default useMemberships;
